module.exports = "// Interval time(ms) for sending message to IoT Hub\r\n#define INTERVAL 2000\r\n\r\n#define MESSAGE_MAX_LEN 256\r\n\r\n#define DEVICE_ID \"AZ3166\"\r\n\r\n#define TEMPERATURE_ALERT 30"


//////////////////
// WEBPACK FOOTER
// ./src/data/GetStarted/config.h
// module id = 400
// module chunks = 0